/**
 *
 */
export default function startVideoPlayer() {
  const $videoContainer = $('.video-container');

  if ($videoContainer.length) {
    const videoID = $videoContainer.attr('data-video-id'); // eslint-disable-line
    const element = $videoContainer[0];

    let playerInstance;

    if ($(document).width() > 800) {
      playerInstance = new WM.Player({ // eslint-disable-line
        height: 360,
        width: 640,
        videosIDs: videoID,
      });
    } else {
      playerInstance = new WM.Player({ // eslint-disable-line
        videosIDs: videoID,
      });
    }

    playerInstance.stopVideo();
    playerInstance.attachTo(element);
  }
}



// WEBPACK FOOTER //
// local_static/templates/vai_vem/2018/assets/scripts/videoPlayer.js